import React from "react";

const Error404 = () => {
  return (
    <>
      <div className="hold-transition login-page">
        <section className="">
          <div className="error-page text-center">
            <h2 className="headline text-warning"> 404</h2>
            <div className="error-content">
              <h3>
                <i className="fas fa-exclamation-triangle text-warning" /> Oops!
                Page not found.
              </h3>
              <p>
                We could not find the page you were looking for. Meanwhile, you
                may <a href="/">return to dashboard</a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Error404;
